// extracted by mini-css-extract-plugin
export default {"buttons":"ModalButtons_buttons__-d1Mb"};